import React, { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { supabaseRentalContractService } from '../../../../services/supabase/rental-contracts';
import type { RentalContract, RentalContractFormData } from '../../../../types/rental-contract';
import RentalContractModal from './RentalContractModal';

interface EditRentalContractModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  rentalContract: RentalContract;
}

export default function EditRentalContractModal({ 
  isOpen, 
  onClose, 
  onSuccess,
  rentalContract
}: EditRentalContractModalProps) {
  const queryClient = useQueryClient();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSave = async (formData: RentalContractFormData) => {
    setIsSubmitting(true);
    setError(null);
    
    try {
      await supabaseRentalContractService.update(rentalContract.rental_trans_id, formData);
      queryClient.invalidateQueries({ queryKey: ['rental-contracts'] });
      onSuccess();
      onClose();
    } catch (err) {
      console.error('Error updating rental contract:', err);
      setError(err instanceof Error ? err.message : 'Failed to update rental contract');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <RentalContractModal
      isOpen={isOpen}
      onClose={onClose}
      onSave={handleSave}
      initialData={rentalContract}
      title="Edit Rental Contract"
    />
  );
}
